export default "__VITE_ASSET__a1c85a28__"